// A technician's pen (DESIGN.md §2: a pen identifies a technician, never a state). A component that
// draws one reads --<prefix>-pen; this sets it on the component's own element to one of its own
// --<prefix>-pen-N tokens (packages/tokens blueprint.components). A token that held var(--x-pen) would
// be fixed where it is defined, on :root, so the pen is set here, per element.
import type { CSSProperties } from 'react';

/** 1 to 8, a technician's pen; null for nobody (the component's own default, muted or ink). */
export type Pen = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/** A component can ask for more than its line: 'wash' also sets --<prefix>-wash to --<prefix>-wash-N. */
export type PenPart = 'pen' | 'wash';

export function penStyle(
  prefix: string,
  pen: Pen | null | undefined,
  parts: readonly PenPart[] = ['pen'],
): CSSProperties | undefined {
  if (!pen) return undefined;
  return Object.fromEntries(
    parts.map((part) => [`--${prefix}-${part}`, `var(--${prefix}-${part}-${pen})`]),
  ) as CSSProperties;
}
